<mat-drawer-container class="countable-drawer-new">
    <mat-drawer-content class="overflow-hidden">
        <div class="component-settings h-100 page-wraper" appSpin [spinnerConfig]='spinnerConfig()'>
            <div class="page-title-block common-head bg-transparent">
                <h1 class="title h3">Letterhead & Signature</h1>
            </div>
            <div class="content-block-main letterhead-tab position-relative pe-0">
                <div class="button-group gap-8 sorting-group pe-4" [ngClass]="{'letterhead-search': isDrawerOpened }">
                    <mat-form-field class="fixed-label label-none icon-form-before width-250" floatLabel="always">
                        <mat-label>Search</mat-label>
                        <input #searchBox  matInput placeholder="Search" autocomplete="off" type="text" maxlength="50"
                            autocomplete="off" (input)="onSearch($event.target.value)">
                        <span matPrefix>
                            <i class="fa-regular fa-magnifying-glass" draggable="false"></i>
                        </span>
                    </mat-form-field>
                    <button mat-button mat-flat-button color="primary" class="button-default"
                    (click)="onAddClick()">
                        <span class="flexbox-row gap-8">
                            <i class="fa-regular fa-plus"></i>
                            <span class="button-label">{{tabIndex() === 0 ? 'Add Header' : tabIndex() === 1 ? 'Add Footer' : 'Add Signature'}}</span>
                        </span>
                    </button>


                </div>
                <mat-tab-group class="h-100 gap-12" (selectedIndexChange)="onChangeTab($event)"
                    animationDuration="0ms">
                    <mat-tab label="Header">
                            <div class="component-settings-body-headers page-wraper w-100">
                                <app-headers class="h-100 overflow-hidden" [searchTerm]="searchTerm()"
                                    (spinnerConfig)="updateSpinnerConfig($event)"></app-headers>
                            </div>
                       
                    </mat-tab>
                    <mat-tab label="Footer">
               
                            <div class="component-settings-body-footers page-wraper w-100">
                                <app-footers class="h-100 overflow-hidden" [searchTerm]="searchTerm()"
                                    (spinnerConfig)="updateSpinnerConfig($event)"></app-footers>
                            </div>
                      
                    </mat-tab>
                    <mat-tab label="Signature">
                  
                            <div class="component-settings-body-signatures page-wraper w-100">
                                <app-signatures class="h-100 overflow-hidden" [searchTerm]="searchTerm()"
                                    (spinnerConfig)="updateSpinnerConfig($event)"></app-signatures>
                            </div>
                      
                    </mat-tab>
                </mat-tab-group>
            </div>
        </div>
        @if(previewToggleVisible()){
        <div class="toogle-button-block button-block-right preview-toggle">
            <button mat-button class="button-medium-icon toogle-button" (click)="drawer.toggle(); isDrawerOpened=true"></button>
            <div class="toogle-content">
                <h6 class="title open-preview">Preview</h6>
            </div>
        </div>
        }
    </mat-drawer-content>
    @if(showDrawer()) {
    <mat-drawer #drawer class="order-2 drawer-from-right prev-right-drawer components-preview-section" position="end"
        appResizableDrawer resizeDirection="left" [minWidth]="600" [maxWidth]="700"
        (resizeEvent)="onResizePanelEnd($event)" >
        @if(showHeaderFooterPreview()) {
        <div class="flexbox-column gap-0 overflow-auto p-3">
            <!-- <div class="page A4 preview-height"> -->
            <div class="page-header" [ngClass]="getImageClassHeader()">                
                <img [src]="(selectedHeader?.resized_JsonFilePath$ | async) || (selectedHeader?.s3JSONFilePath$ | async)"
                    (load)="adjustHeight($event)" />
            </div>


            <div class="page-content d-flex flex-column align-items-left gap-8">
                <p>22 - 12 - 2022</p>
                <p class="mt-2">Arthur Conrad</p>
                <p>Xero Inc.</p>
                <p>Vienna Virginia</p>
                <p>&nbsp;</p>
                <p><span class="fw-bold">Subject: Compiled financial information for</span> Xero Inc.</p>
                <p>&nbsp;</p>
                <p><span class="fw-bold">Dear</span> Arthur Conrad</p>

                <p>
                    You have requested that, on the basis of information that you will provide, we assist
                    you in the preparation of the compiled financial information of Xero Inc., which
                    comprise the balance sheet as at Dec 31, 2022 and the statement of income and retained
                    earnings for the year then ended, and Note , which describes the basis of accounting to
                    be applied in the preparation of the compiled financial information.
                </p>

                <p>
                    The compiled financial information is intended to be used by management of Xero Inc.and
                    third parties, being [e.g., current or potential lenders, suppliers, stakeholders].
                    Those parties are in a position to request and obtain further information from the
                    entity.
                </p>

                <p>
                    We are pleased to confirm our acceptance and our understanding of this compilation
                    engagement by means of this letter.
                </p>
            </div>


            <div class="page-footer" [ngClass]="getImageClassFooter()">
                <img [src]="(selectedFooter?.resized_JsonFilePath$ | async) || (selectedFooter?.s3JSONFilePath$ | async)"
                    (load)="checkDimensions($event)" />
            </div>
            <!-- </div> -->
        </div>
        }
        @if(showEmptyHeader()) {
        <div class="preview-section flexbox-column gap-0 overflow-auto p-3">
            <div class="mx-3">
                <div class="no-data-found">
                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon" />
                    <h6>No Header Added</h6>
                    <p>You have not added any headers.</p>
                    <p>To view the preview of the header, click the</p>
                    <p>'Adds Header' button to get started.</p>
                </div>
            </div>
        </div>
        }
        @if(showHeaderOnly()) {
        <div class="preview-section flexbox-column gap-0 overflow-auto p-3">
            <div class="mx-3">
                <div class="page A4 preview-height">
                    <div class="page-header" [ngClass]="getImageClassHeader()">
                        <img [src]="(selectedHeader?.resized_JsonFilePath$ | async) || (selectedHeader?.s3JSONFilePath$ | async)"
                    (load)="adjustHeight($event)" />
                    </div>


                    <div class="page-content d-flex flex-column align-items-left gap-8">
                        <p>22 - 12 - 2022</p>
                        <p class="mt-2">Arthur Conrad</p>
                        <p>Xero Inc.</p>
                        <p>Vienna Virginia</p>
                        <p>&nbsp;</p>
                        <p><span class="fw-bold">Subject: Compiled financial information for</span> Xero Inc.</p>
                        <p>&nbsp;</p>
                        <p><span class="fw-bold">Dear</span> Arthur Conrad</p>

                        <p>
                            You have requested that, on the basis of information that you will provide, we assist
                            you in the preparation of the compiled financial information of Xero Inc., which
                            comprise the balance sheet as at Dec 31, 2022 and the statement of income and retained
                            earnings for the year then ended, and Note , which describes the basis of accounting to
                            be applied in the preparation of the compiled financial information.
                        </p>

                        <p>
                            The compiled financial information is intended to be used by management of Xero Inc.and
                            third parties, being [e.g., current or potential lenders, suppliers, stakeholders].
                            Those parties are in a position to request and obtain further information from the
                            entity.
                        </p>

                        <p>
                            We are pleased to confirm our acceptance and our understanding of this compilation
                            engagement by means of this letter.
                        </p>
                    </div>



                    <div class="page-footer flexbox-row bg-gray-3 justify-content-center">
                        <p class="text-center">footer goes here</p>
                    </div>
                </div>
            </div>
        </div>
        }
        @if(showEmptyFooter()) {
        <div class="preview-section flexbox-row overflow-auto">
            <div class="mx-3">
                <div class="no-data-found">
                    <img src="./assets/images/ui-uplift-icons/global/empty-component-icon.svg" alt="Icon" />
                    <h6>No Footer Added</h6>
                    <p>You have not added any footers.</p>
                    <p>To view the preview of the footer, click the</p>
                    <p>'Add Footer' button to get started.</p>
                </div>
            </div>
        </div>
        }
        @if(showFooterOnly()) {
        <div class="preview-section flexbox-row overflow-auto">
            <div class="mx-3">
                <div class="page A4 preview-height">
                    <div class="page-header flexbox-row bg-gray-3 justify-content-center">
                        <p class="text-center">Header goes here</p>
                    </div>


                    <div class="page-content d-flex flex-column align-items-left gap-8">
                        <p>22 - 12 - 2022</p>
                        <p class="mt-2">Arthur Conrad</p>
                        <p>Xero Inc.</p>
                        <p>Vienna Virginia</p>
                        <p>&nbsp;</p>
                        <p><span class="fw-bold">Subject: Compiled financial information for</span> Xero Inc.</p>
                        <p>&nbsp;</p>
                        <p><span class="fw-bold">Dear</span> Arthur Conrad</p>

                        <p>
                            You have requested that, on the basis of information that you will provide, we assist
                            you in the preparation of the compiled financial information of Xero Inc., which
                            comprise the balance sheet as at Dec 31, 2022 and the statement of income and retained
                            earnings for the year then ended, and Note , which describes the basis of accounting to
                            be applied in the preparation of the compiled financial information.
                        </p>

                        <p>
                            The compiled financial information is intended to be used by management of Xero Inc.and
                            third parties, being [e.g., current or potential lenders, suppliers, stakeholders].
                            Those parties are in a position to request and obtain further information from the
                            entity.
                        </p>

                        <p>
                            We are pleased to confirm our acceptance and our understanding of this compilation
                            engagement by means of this letter.
                        </p>
                    </div>


                    <div class="page-footer" [ngClass]="getImageClassFooter()">
                        <img [src]="(selectedFooter?.resized_JsonFilePath$ | async) || (selectedFooter?.s3JSONFilePath$ | async)"
                    (load)="checkDimensions($event)" />
                    </div>
                </div>
            </div>
        </div>
        }
    </mat-drawer>
    }
</mat-drawer-container>